import moment from 'moment';
import { ExportService } from "../ExportService";
import { accounts, CAMT05X, statements, VALUES } from '../../arsweb/RoutingPaths';
import { REPORT_TYPE } from "../../../components/report/ReportModalController";

/** @ngInject */
export class CAMT05XService extends ExportService {
    constructor(ArsConfig, userService) {
        super(ArsConfig, userService);
    }

    /**
     * Extracts the numeric ID from a restUrl like:
     * /intradays/121236648/transactions?
     * /statements/884334775/transactions?
     */
    extractIdFromUrl(url) {
        const match = url?.match(/\/(?:intradays|statements)\/(\d+)\/transactions/);
        return match ? match[1] : null;
    }

    /**
     * Download the CAMT05X file
     * @param controller
     * @param selectedElements: omitted when the filter is used (group cases)
     * @returns {*}
     */
    downloadCAMT05X(controller, selectedElements, params) {
        const { reportType } = params;
        const service = this.getService(controller);

        const endpoint = `${CAMT05X}${accounts}${statements}${VALUES}`;

        let ids = selectedElements;

        if (
            reportType === REPORT_TYPE.CAMT052_ACTUAL_INTRADAY ||
            reportType === REPORT_TYPE.CAMT053_ACTUAL_STATEMENT
        ) {
            const extractedId = this.extractIdFromUrl(controller.restUrl);
            ids = extractedId ? [extractedId] : [];
        }

        const body = {
            type: reportType.type,
            title: `${reportType.type.toLowerCase()}_${moment().format('DDMMYYYY_HHmm')}`,
            ids: ids
        };

        controller.promise = controller.confirmAsynch().then((result) => {
            if(_.isNil(result)) {
                service.postUserReport(endpoint, body)
            }
        });
    }
}